import cx from "classnames";
import noop from "lodash/noop";
import PropTypes from "prop-types";
import React, { Component, Fragment } from "react";

import ImageAttachmentOverlay from "./ImageAttachmentOverlay";
import Loader from "./Loader";
import Portal from "../../utils/Portal";
import SvgIcon from "./SvgIcon";

import iconSprite from "../../../../images/img/chat/icons.svg";

export default class ImageAttachment extends Component {
    constructor() {
        super();

        this.state = {
            errored: false,
            isLoadingThumbnail: true,
            isLoadingOriginal: false,
            isOriginalOpen: false,
        };

        this.onCloseOriginalImage = this.onCloseOriginalImage.bind(this);
        this.onThumbnailClick = this.onThumbnailClick.bind(this);
        this.onThumbnailError = this.onThumbnailError.bind(this);
        this.onThumbnailLoad = this.onThumbnailLoad.bind(this);
        this.onOpenOriginalImage = this.onOpenOriginalImage.bind(this);
    }

    componentWillUnmount() {
        this.props.onCloseOriginalImage();
    }

    onCloseOriginalImage() {
        this.setState(() => ({ isOriginalOpen: false }), this.props.onCloseOriginalImage);
    }

    onThumbnailLoad() {
        if (this.state.isLoadingThumbnail) {
            this.setState(() => ({ isLoadingThumbnail: false }), this.props.onThumbnailLoad);
        }
    }

    onOpenOriginalImage() {
        this.setState(
            () => ({
                isLoadingThumbnail: false,
                isLoadingOriginal: false,
            }),
            this.props.onOpenOriginalImage
        );
    }

    onThumbnailClick() {
        this.setState(() => ({
            isLoadingOriginal: true,
            isOriginalOpen: true,
        }));
    }

    onThumbnailError() {
        this.setState(() => ({
            errored: true,
            isLoadingThumbnail: false,
        }));
    }

    render() {
        const { alt, className, originalSrc, thumbnailSrc } = this.props;
        const { errored, isLoadingOriginal, isLoadingThumbnail, isOriginalOpen } = this.state;

        return (
            <span
                className={cx("ImageAttachment", className, {
                    "ImageAttachment--hasErrored": errored,
                    "ImageAttachment--isLoadingThumbnail": isLoadingThumbnail,
                    "ImageAttachment--isLoadingOriginal": isLoadingOriginal,
                })}
            >
                {isLoadingOriginal && <Loader as="span" />}
                {!errored && thumbnailSrc && (
                    <img
                        alt={alt}
                        onClick={this.onThumbnailClick}
                        onError={this.onThumbnailError}
                        onLoad={this.onThumbnailLoad}
                        src={thumbnailSrc}
                    />
                )}
                {!isLoadingThumbnail && errored && (
                    <Fragment>
                        <SvgIcon src={iconSprite} id="icon-broken-file" />
                        <p className="body">{i18n.t("rtm.error.something_wrong_with_file")}</p>
                    </Fragment>
                )}
                {isOriginalOpen && (
                    <Portal>
                        <ImageAttachmentOverlay
                            closeButton={
                                <button
                                    className="ImageAttachment__closeButton"
                                    onClick={this.onCloseOriginalImage}
                                    type="button"
                                >
                                    <SvgIcon src={iconSprite} id="icon-rounded-close" />
                                </button>
                            }
                            onClose={this.onCloseOriginalImage}
                            onOpen={this.onOpenOriginalImage}
                            src={originalSrc}
                        />
                    </Portal>
                )}
            </span>
        );
    }
}

ImageAttachment.defaultProps = {
    alt: "",
    className: "",
    onThumbnailLoad: noop,
};

ImageAttachment.propTypes = {
    alt: PropTypes.string,
    className: PropTypes.string,
    thumbnailSrc: PropTypes.string.isRequired,
    onCloseOriginalImage: PropTypes.func.isRequired,
    onOpenOriginalImage: PropTypes.func.isRequired,
    onThumbnailLoad: PropTypes.func,
    originalSrc: PropTypes.string.isRequired,
};
